export default function openVideo() {
  let modal = $('.modalVideo');
  let speed = 'slow';
  let iframe = 'iframe';
  let openVideo = $('[data-openvideo]');
  let closeVideo = $('[data-closemodal]');
  openVideo.click(function () {
    modal.fadeIn(speed);
    modal.find(iframe).attr('src', $(this).data('video'));
  });
  closeVideo.click(() => {
    modal.fadeOut(speed);
    modal.find(iframe).attr('src', '');
  });
}